import { c as _c } from "react/compiler-runtime";
import { Text } from '@newfront-insurance/core-ui';
import type { CurrencyOrCheckboxInputMetadata } from '@newfront-insurance/coverage-api';
import type { SchemaInputControlCustomInputProps, CustomValue } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';
import { AddressDisplayField, AddressFormattedText, AddressSelector } from '../../../../../address';
export type AddressValue = Record<string, string | undefined> | undefined;
export function AddressDslInput(t0) {
  const $ = _c(6);
  const {
    onChange,
    value,
    accountUuid
  } = t0;
  if (!accountUuid) {
    let t1;
    if ($[0] !== value) {
      t1 = <AddressDisplayField address={value} width="100%" />;
      $[0] = value;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== accountUuid || $[3] !== onChange || $[4] !== value) {
    t1 = <AddressSelector accountUuid={accountUuid} onChange={onChange} selectedAddress={value} width={400} />;
    $[2] = accountUuid;
    $[3] = onChange;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, react/function-component-definition
export const AddressDslDisplay: CustomValue<any, Omit<CurrencyOrCheckboxInputMetadata, 'label'>> = t0 => {
  const $ = _c(5);
  const {
    value,
    size,
    color,
    weight
  } = t0;
  let t1;
  if ($[0] !== color || $[1] !== size || $[2] !== value || $[3] !== weight) {
    t1 = value ? <AddressFormattedText address={value} /> : <Text prewrap={true} size={size} color={color} weight={weight}>-</Text>;
    $[0] = color;
    $[1] = size;
    $[2] = value;
    $[3] = weight;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};